import React, {Component} from 'react';
import { Route, Switch, Redirect } from 'react-router-dom';
import { ConnectedRouter } from 'react-router-redux';
import { connect } from 'react-redux';
import asyncComponent from './helpers/AsyncFunc';
import page404 from './component/404'

class PublicRoutes extends Component {
    render() {
        const {history} = this.props;
        return (
            <ConnectedRouter history={history}>
                <Switch>
                    <Route exact path="/register" component={asyncComponent(() => import('./component/register'))} />
                    <Route exact path="/status" component={asyncComponent(() => import('./component/statusPage'))} />
                    <Route exact path="/health/" component={page404} />
                    <Route exact path="/" render={() => (<Redirect to="/register" />)} />          
                    <Route path="*" component={page404} />          
                </Switch>
            </ConnectedRouter>
        )
    }
}

export default connect(
    state => ({
    })
)(PublicRoutes);



// WEBPACK FOOTER //
// ./src/router.js